import { devtools, subscribeWithSelector } from "zustand/middleware";
import { create } from "zustand";
import { type GetDraftBotInfoAgwData } from "@coze-arch/idl/playground_api";
import {globalInputParmsItems} from '@rokid/const'


export type GlobalImageSize = 0 | 4; //0-低进度，4-高精度

export interface ParameterStoreProps {
  inputParameterType: string;
  globalImagesize: 0 | 4;
}
//更新智能体启动设置
export interface ParameterStoreActions {
  setInputParameterType: (inputParameterType: string) => void;
  initStore: (data: GetDraftBotInfoAgwData) => void;
  setGlobalImagesize: (globalImagesize: GlobalImageSize) => void;
}

//初始化默认值
export const getDefaultParameterStore = (): ParameterStoreProps => ({
  inputParameterType: 'question', //默认文字输入
  globalImagesize: 0
});

export const useParameterStore = create<ParameterStoreProps & ParameterStoreActions>()(
  devtools(
    subscribeWithSelector((set, get) => ({
      ...getDefaultParameterStore(),
      setInputParameterType: (inputParameterType: string) => {
        set({ inputParameterType });
      },
      setGlobalImagesize: (globalImagesize: GlobalImageSize) => {
        set({ globalImagesize });
      },
      initStore: (data) => {
        const { bot_info } = data;
        const { param_config } = bot_info;
        if (param_config) {
          set({
            inputParameterType: param_config.param_type as string || 'question',
            globalImagesize: param_config.global_image_size as GlobalImageSize 
          });
        } else {
          set({
            inputParameterType: 'question',
            globalImagesize: 0
          });
        }
      },
      clear: () => {
        set({ ...getDefaultParameterStore() });
      },
    })),
  ),
);
